import { SoftphoneConnectionBehaviorEnum, UserRoleKeyEnum } from '@lib/enums';
import { hasAnyRole } from '@lib/utils/hasAnyRole';

import type { TUser } from '@models/authorization/TUser';

const OPT_IN_ROLE_KEYS: readonly UserRoleKeyEnum[] = [
  UserRoleKeyEnum.SalesManager,
  UserRoleKeyEnum.SalesDirector,
  UserRoleKeyEnum.CustomerServiceManager,
  UserRoleKeyEnum.SuperAdmin,
];

const DO_NOT_CONNECT_ROLE_KEYS: readonly UserRoleKeyEnum[] = [
  UserRoleKeyEnum.ReadOnly,
  UserRoleKeyEnum.BusinessAdmin,
  UserRoleKeyEnum.QualityAssurance,
  UserRoleKeyEnum.ClaimsAdjuster,
  UserRoleKeyEnum.BillingLeadership,
  UserRoleKeyEnum.PaymentsManager,
  UserRoleKeyEnum.RetentionManager,
  UserRoleKeyEnum.Resolutions,
];

export function getSoftphoneConnectionBehavior(
  roles: TUser['roles'],
): SoftphoneConnectionBehaviorEnum {
  if (hasAnyRole(roles, OPT_IN_ROLE_KEYS)) {
    return SoftphoneConnectionBehaviorEnum.OptIn;
  }

  if (hasAnyRole(roles, DO_NOT_CONNECT_ROLE_KEYS)) {
    return SoftphoneConnectionBehaviorEnum.DoNotConnect;
  }

  return SoftphoneConnectionBehaviorEnum.AutoConnect;
}
